module.exports = __webpack_public_path__ + "img/pslogo2.cf718c94.png";